/**
 * Appends the raw OCR response as JSON so the backend can persist field-level
 * confidence and reason metadata without exposing it in the editable form.
 */
export const appendOcrMetadata = (
  formData: FormData,
  parameter: string,
  ocrResponse?: Record<string, unknown> | null,
) => {
  if (!ocrResponse || Object.keys(ocrResponse).length === 0) return;

  formData.append(parameter, JSON.stringify(ocrResponse));
};
